import { API_HOST, API_KEY } from "../utils/const";
import { registrarFalloConexion } from "../utils/logConexionFallo";

const DEFAULT_FETCH_TIMEOUT_MS = 20000;

export const fetchRequest = async (url, config) => {
  let { method, headers, body, token, time } = config;
  let timeout = time ?? DEFAULT_FETCH_TIMEOUT_MS;
  if (method != "GET") {
    body = JSON.stringify(body);
    headers = { "Content-Type": "application/json", ...headers };
  }
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      const err = {
        error: 'No se puede conectar al servidor',
        response: 408,
        message: 'Request timeout',
      };
      registrarFalloConexion({
        baseUrl: API_HOST,
        url,
        providerLabel: 'conect',
        token,
        error: err,
      });
      reject(err);
    }, timeout);

    fetch(`${API_HOST}/${url}`, {
      body: body,
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        apiKey: API_KEY,
      },
      method: method,
    })
      .then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          const json = await response.json();
          if (json) {
            clearTimeout(timer);
            resolve(json);
          }
        } else if (response.status >= 300) {
          const json = await response.json();
          if (json) {
            clearTimeout(timer);
            reject(json);
          }
        }
      })
      .catch((error) => {
        clearTimeout(timer);
        registrarFalloConexion({
          baseUrl: API_HOST,
          url,
          providerLabel: 'conect',
          token,
          error: { error },
        });
        reject({ error });
      });
  });
};

